import React, {FC} from 'react'

import {observer} from 'mobx-react-lite'

import PayStubItemStore from 'models/PayStub/PayStubItem.store'
import {usePayStubStore} from 'src/utils/contexts/RootStore.context'

import {ItemDeductions} from './ItemDeductions'

interface IItemDeductionsListProps {
	store: PayStubItemStore
}

const ItemDeductionsList: FC<IItemDeductionsListProps> = ({store: item}) => {
	const {isAutoCalculation, setDeductionsCustomName, removeDeductionsItem} = usePayStubStore()
	return (
		<>
			{[...Object.values(item.deductions), ...item.customDeductions].map((deductionItem) => {
				if (!deductionItem) return null
				const {id} = deductionItem
				return (
					<ItemDeductions
						key={id}
						store={deductionItem}
						isReadOnly={isAutoCalculation}
						setCustomName={(e) => setDeductionsCustomName(e, id)}
						removeItem={() => removeDeductionsItem(id)}
					/>
				)
			})}
		</>
	)
}

ItemDeductionsList.displayName = 'ItemDeductionsList'

export default observer(ItemDeductionsList)
